import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
application.debug = false
window.Stimulus = application

// rejestruje automatycznie każdy plik *_controller.js z tego katalogu (hello_controller.js -> data-controller="hello")
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)
